const config = {
  development: {
    server: "http://192.168.0.46:9010/",
    // bigScreenApiBase: "http://111.160.87.82:8037/",
    // server: "https://56gangkou.com/mob_api/",
    // server: "http://111.160.87.82:8037/",
    // server: "http://192.168.11.104:9010/",
    // server: "http://192.168.31.47:9010",
    bigScreenApiBase: "https://56gangkou.com/mob_api/",
  },
  production: {
    // server: "http://192.168.0.75:9010/",
    // server: "http://192.168.11.104:9010/",
    // server: "http://111.160.87.82:8037/",
    server: "https://56gangkou.com/mob_api/",
    bigScreenApiBase: "https://56gangkou.com/mob_api/",
  },
};

export default config[process.env.NODE_ENV];

// process.env.NODE_ENV === "development"
//   ? "http://111.160.87.82:8037/"
//   : "https://56gangkou.com/mob_api/";
